import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
const Input = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("input", Object.assign({ ref: ref }, props, { className: clsx('cmp-input', className) })));
});
Input.displayName = 'Input';
export { Input };
//# sourceMappingURL=Input.js.map